import React from "react";

const AepsDashboard = () => {
  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex-1 p-4 rounded-lg shadow-md overflow-auto">
        <h1 className="text-2xl font-bold text-center mb-6 text-primary">AEPS Dashboard</h1>
        <div className="mt-8 bg-gray-50 rounded-lg p-6 min-h-[200px] flex items-center justify-center text-gray-400">
          <span>Charts and detailed analytics coming soon...</span>
        </div>
      </div>
    </div>
  );
};

export default AepsDashboard;